import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import Loading from "../../../../../../components/shared/Loading";
import PageContainer from "../../../../../../components/template/PageContainer";
import { validateAdminParams } from "../../../../../../router/admin-validation";
import { requireRoles } from "../../../../../../router/auth";
import type { RouteMetadata } from "../../../../../../router/metadata";

const Screen = lazy(
  () => import("../../../../../../views/administrator/models"),
);

export const Route = createFileRoute(
  "/_protected/(admin)/theme/$themeId/models/new",
)({
  component: RouteComponent,
  beforeLoad: ({ context }) => requireRoles(context.authSnapshot, ["Admin"]),
  params: {
    parse: validateAdminParams,
  },
  staticData: {
    routeKey: "theme-models",
    access: "admin",
    layout: "modern",
    container: "default",
    requiredRoles: ["Admin"],
    footer: false,
    mode: "new",
  } satisfies RouteMetadata,
});

function RouteComponent() {
  return (
    <Suspense fallback={<Loading loading={true} />}>
      <PageContainer
        pageContainerType={Route.options.staticData?.container}
        footer={Route.options.staticData?.footer}
      >
        <Screen />
      </PageContainer>
    </Suspense>
  );
}
